import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';


@Component({
  template: `
  <button *ngIf="value === 'NOT_STARTED'" title="Não iniciado" nbButton style="cursor: auto; border-color: #9DACBA; margin-left: 10px; background-color: #9DACBA;color:white;" shape="round" size="tiny">Não iniciado</button>
                            <button *ngIf="value === 'IN_PROGRESS'" title="Em progresso" nbButton style="cursor: auto; border-color: #006b9c; margin-left: 10px; background-color: #006b9c;color:white;" shape="round" size="tiny">Em progresso</button>
                            <button *ngIf="value === 'FINISHED'" title="Encerrado" nbButton style="cursor: auto; border-color: #F9B64F; margin-left: 10px; background-color: #F9B64F;color:white;" shape="round" size="tiny">Encerrado</button>
  `,
})
export class ColumnStatusPeriodComponent implements ViewCell, OnInit {

  renderValue: string;

  @Input() value: string | number;
  @Input() rowData: any;

  classToApply = '';
  color = '';
  status = '';
  messageTooltip = '';

  ngOnInit() {
    if (this.value === 'FINISHED') {
      this.classToApply = 'far fa-check-circle';
      this.color = '#2ce69b';
      this.messageTooltip = 'Encerrado';
      this.status = 'basic';
    } else if (this.value === 'IN_PROGRESS') {
      this.classToApply = 'fas fa-hourglass-half';
      this.color = '#006b9c';
      this.messageTooltip = 'Em progresso';
      this.status = 'basic';
    } else {
      this.classToApply = 'far fa-clock';
      this.color = '#46a0ff';
      this.messageTooltip = 'Não iniciado';
      this.status = 'basic';
    }
    this.renderValue = this.value.toString().toUpperCase();
  }
}
